// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arabic-search-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  height: 68px;
  width: 50%;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  border-bottom: 2px solid #cccccc;
  border-radius: 36px;
  background-color: #ffffff;
}

@media (max-width: 900px) {
  .arabic-search-bar {
    width: 80%;
  }
}

@media (max-width: 500px) {
  .arabic-search-bar {
    width: 95%;
  }
}

.arabic-keyboard-icon {
  color: #999999;
  height: 26px;
  padding: 5px 20px 0px 10px;
  align-items: center;
  justify-content: center;
}

@media (max-width: 500px) {
  .arabic-keyboard-icon {
    margin-right: 10px;
  }
}

.arabic-text-input {
  flex: 1 1;
  border: none;
  padding: 5px;
  font-family: Roboto;
  font-size: 22px;
  outline: none;
  direction: rtl;
}

.arabic-filter-styles-control {
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 36px;
  margin-left: 0.7em;
}

.arabic-filter-styles-placeholder {
  font-size: 1em;
  font-weight: 400;
}

.arabic-filter-styles-option {
  background-color: #e5e5e5;
  color: #ffffff;
}

.arabic-option-arrow {
  color: #cc0000;
  height: 16px;
}

.arabic-semantic-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 16px;
  font-family: Roboto;
  font-size: 16px;
  color: #333333;
  direction: rtl;
}

.arabic-semantic-toggle input {
  width: 18px;
  height: 18px;
}

.arabic-search-icon {
  align-items: center;
  justify-content: end;
  color: #cc0000;
  height: 20px;
  padding-left: 20px;
  margin-right: 0.8em;
}

.arabic-right-up-arrow {
  color: #808080;
  height: 12px;
  margin-left: 10px;
}

@media (max-width: 650px) {
  .arabic-right-up-arrow {
    display: none;
  }
}

.arabic-text-below-search-box-div {
  display: flex;
  color: #808080;
  font-size: 14px;
  line-height: 150%;
  height: 24px;
  font-family: Roboto-Slab;
  font-style: normal;
  font-weight: 400;
  margin-top: 5px;
  transform: translateX(-31%);
  margin-left: 12rem;
}

@media (max-width: 1100px) {
  .arabic-text-below-search-box-div {
    margin-right: 40px;
  }
}

.arabic-search-div {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/styles-arabic/search-input.rtl.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".arabic-search-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: visible;\n  height: 68px;\n  width: 50%;\n  border-top: 0;\n  border-right: 0;\n  border-left: 0;\n  border-bottom: 2px solid #cccccc;\n  border-radius: 36px;\n  background-color: #ffffff;\n}\n\n@media (max-width: 900px) {\n  .arabic-search-bar {\n    width: 80%;\n  }\n}\n\n@media (max-width: 500px) {\n  .arabic-search-bar {\n    width: 95%;\n  }\n}\n\n.arabic-keyboard-icon {\n  color: #999999;\n  height: 26px;\n  padding: 5px 20px 0px 10px;\n  align-items: center;\n  justify-content: center;\n}\n\n@media (max-width: 500px) {\n  .arabic-keyboard-icon {\n    margin-right: 10px;\n  }\n}\n\n.arabic-text-input {\n  flex: 1;\n  border: none;\n  padding: 5px;\n  font-family: Roboto;\n  font-size: 22px;\n  outline: none;\n  direction: rtl;\n}\n\n.arabic-filter-styles-control {\n  background-color: #ffffff;\n  border: 1px solid #cccccc;\n  border-radius: 36px;\n  margin-left: 0.7em;\n}\n\n.arabic-filter-styles-placeholder {\n  font-size: 1em;\n  font-weight: 400;\n}\n\n.arabic-filter-styles-option {\n  background-color: #e5e5e5;\n  color: #ffffff;\n}\n\n.arabic-option-arrow {\n  color: #cc0000;\n  height: 16px;\n}\n\n.arabic-semantic-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 16px;\n  font-family: Roboto;\n  font-size: 16px;\n  color: #333333;\n  direction: rtl;\n}\n\n.arabic-semantic-toggle input {\n  width: 18px;\n  height: 18px;\n}\n\n.arabic-search-icon {\n  align-items: center;\n  justify-content: end;\n  color: #cc0000;\n  height: 20px;\n  padding-left: 20px;\n  margin-right: 0.8em;\n}\n\n.arabic-right-up-arrow {\n  color: #808080;\n  height: 12px;\n  margin-left: 10px;\n}\n\n@media (max-width: 650px) {\n  .arabic-right-up-arrow {\n    display: none;\n  }\n}\n\n.arabic-text-below-search-box-div {\n  display: flex;\n  color: #808080;\n  font-size: 14px;\n  line-height: 150%;\n  height: 24px;\n  font-family: Roboto-Slab;\n  font-style: normal;\n  font-weight: 400;\n  margin-top: 5px;\n  transform: translateX(-31%);\n  margin-left: 12rem;\n}\n\n@media (max-width: 1100px) {\n  .arabic-text-below-search-box-div {\n    margin-right: 40px;\n  }\n}\n\n.arabic-search-div {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  margin-top: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
